import React, { useState, createContext, useContext, useEffect } from 'react';
import { useScrollTrigger } from '@mui/material';

const ScrollContext = createContext();

export const useSetScrollTarget = () => {
  const [, setIsScrolling] = useContext(ScrollContext);
  const [scrollTarget, setScrollTarget] = useState(window);

  const trigger = useScrollTrigger({
    threshold: 0,
    target: scrollTarget,
    disableHysteresis: true
  });

  useEffect(() => {
    setIsScrolling(trigger);
  }, [setIsScrolling, trigger]);

  return setScrollTarget;
};

export const useIsScrolling = () => {
  const [isScrolling] = useContext(ScrollContext);
  return isScrolling;
};

const ScrollProvider = ({ children }) => {
  const scrollState = useState(false);

  return <ScrollContext.Provider value={scrollState}>{children}</ScrollContext.Provider>;
};

export default ScrollProvider;
